import clsx from 'clsx';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  apparent?: 'primary' | 'secondary' | 'terciary' | 'warning' | 'worklog' ;
}

export function Button({ children, className, apparent= 'primary', ...rest }: ButtonProps) {
  return (
    <button
      {...rest}
      className={clsx(
        'flex items-center justify-center content-center rounded-lg  px-4 text-sm text-center font-medium transition-colors focus-visible:outline focus-visible:outline-none focus-visible:outline-offset-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50 hover:text-white hover:animate-bounce',
        className,
        {
          'bg-primary-400 text-gray-900 hover:bg-secondary-400 h-10 ': apparent === 'primary',
          'bg-gray-200 md:text-gray-700 hover:bg-terciary-400 h-10 ': apparent === 'secondary',
          'bg-white hover:bg-terciary-400 h-10 ': apparent === 'terciary',
          'bg-terciary-400 text-white hover:bg-gray-400 h-10 ': apparent === 'warning',
          'bg-white flex-col rounded-xl shadow-lg md:shadow-none hover:bg-secondary-400 size-24 md:size-28 2xl:size-44 p-2': apparent === 'worklog',
        }
         
      )}
    >
      {children}
    </button>
  );
}
